import React from 'react';
import styles from './no-latest-news.module.scss';

interface Props {
  category?: string;
}

const NoLatestNews: React.FC<Props> = ({ category }) => (
  <div className={styles.NoLatestNewsContainer}>
    {category ? `No posts in ${category}` : 'No latest news'}
  </div>
);

export default NoLatestNews;
